import React, { useState } from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { Field, Form } from "react-final-form";
import { BasicIcon, TextInput } from "@pickit/pickit-components";
import CountrySelector from "component/countrySelector/CountrySelector";
import { LoginFormType, LoginTypeProps } from "./types";
import useValidationSchema from "hooks/useValidationSchema";
import "./Login.scss";
import { ReactComponent as Logo } from "./../../assets/canguroLogo.svg";
import { ReactComponent as LogoText } from "./../../assets/pickers.svg";
import { useTranslation } from "react-i18next";
import "./i18n";

const Login: React.FC<LoginTypeProps> = ({
  validationSchema,
  isFetching,
  countryCode,
  testId,
  onSubmit,
  updateCountryCode,
}): JSX.Element => {
  const { t } = useTranslation("login");
  const [showPassword, togglePasswordVisibility] = useState(false);

  return (
    <div className="background-login">
      <div className="login-logo-container">
        <Logo />
        <LogoText height={45} width={158} />
      </div>
      <Form
        onSubmit={(values: LoginFormType) => onSubmit(values)}
        validate={useValidationSchema(validationSchema)}
      >
        {({ invalid, handleSubmit }) => (
          <form className="login-form" onSubmit={handleSubmit}>
            <Field
              type="text"
              name="email"
              label={t("user")}
              component={TextInput}
              showClearIcon={false}
              maxLength={50}
              testId={`${testId}-email`}
            />
            <Field
              textType={showPassword ? "text" : "password"}
              name="password"
              label={t("password")}
              showClearIcon={false}
              component={TextInput}
              iconComponent={
                <div
                  className="eye-icon-container"
                  data-testId={`${testId}-show-password`}
                >
                  <BasicIcon
                    name={showPassword ? "eye-off" : "eye"}
                    onClick={() => togglePasswordVisibility((prev) => !prev)}
                  />
                </div>
              }
              maxLength={20}
              testId={`${testId}-password`}
            />
            <p
              className="country-selector-title"
              data-testId={`${testId}-country-selector-title`}
            >
              {t("countryOfOperation")}
            </p>
            <CountrySelector
              actualCountry={countryCode}
              changeCountry={updateCountryCode}
              testId={`${testId}-country-selector`}
            />
            <div className="container-animation">
              <button
                className={classNames("login-button", {
                  "shineBorder-login": isFetching,
                  "button-disabled": invalid,
                })}
                disabled={isFetching || invalid}
                type="submit"
                name="button"
                data-testId={`${testId}-submit-button`}
              >
                <p
                  className="login-init"
                  data-testId={`${testId}-submit-button-label`}
                >
                  {t("login")}
                </p>
              </button>
            </div>
          </form>
        )}
      </Form>
      <div className="container-login-link">
        <Link
          className="login-link"
          to="/restore"
          data-testId={`${testId}-forgot-password-link`}
        >
          {t("forgotPassword")}
        </Link>
      </div>
    </div>
  );
};
export default Login;
